import { RoomColor } from '../enums/RoomColor';

const DEFAULT_ROOM_BG = '#f3f4f6';
const DEFAULT_ROOM_TEXT = '#111827';

const ROOM_BG_COLORS: Record<string, string> = {
  [RoomColor.YELLOW]: '#fef3c7',
  [RoomColor.RED]: '#fee2e2',
  [RoomColor.GREEN]: '#dcfce7',
  [RoomColor.BLUE]: '#dbeafe',
  [RoomColor.WHITE]: '#f9fafb',
  [RoomColor.BLACK]: '#1f2937',
};

const ROOM_TEXT_COLORS: Record<string, string> = {
  [RoomColor.YELLOW]: '#111827',
  [RoomColor.RED]: '#7f1d1d',
  [RoomColor.GREEN]: '#14532d',
  [RoomColor.BLUE]: '#1e3a8a',
  [RoomColor.WHITE]: '#111827',
  [RoomColor.BLACK]: '#f9fafb',
};

function normalizeRoomColor(color: RoomColor | string | null | undefined): string {
  return typeof color === 'string' ? color.trim().toUpperCase() : '';
}

export function getRoomColorHex(color: RoomColor | string | null | undefined): string {
  const normalizedColor = normalizeRoomColor(color);
  return ROOM_BG_COLORS[normalizedColor] || DEFAULT_ROOM_BG;
}

export function getRoomColorTextHex(color: RoomColor | string | null | undefined): string {
  const normalizedColor = normalizeRoomColor(color);
  return ROOM_TEXT_COLORS[normalizedColor] || DEFAULT_ROOM_TEXT;
}
